import { useTranslation } from 'react-i18next';

export const useStatutoryTimelinessResponseStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('statutory_timelines_response_stats_annual_dfi_report');

  const statutoryTimelinessResponseStatsLabels: Record<string, string> = {
    totalConsultationRequestsReceived: t(
      'total_consultation_requests_received',
      'Total number of statutory consultation requests received'
    ),
    totalConsultationsRespondedInAgreedTimeframe: t(
      'total_consultations_responded_in_agreed_timeframe',
      'Total number of statutory consultation requests responded to with a substantive response within the agreed timeframe'
    ),
    percentageConsultationsRespondedInAgreedTimeframe: t(
      'percentage_consultations_responded_in_agreed_timeframe',
      'Percentage of statutory consultation requests responded to with a substantive response within the agreed timeframe'
    ),
    totalConsultationsWithResponsesWithin21Days: t(
      'total_consultations_with_responses_within_21_days',
      'Total number of statutory consultation requests responded to with a substantive response within 21 days'
    ),
    percentageConsultationsWithResponsesWithin21Days: t(
      'percentage_consultations_with_responses_within_21_days',
      'Percentage of statutory consultation requests responded to with a substantive response within 21 days'
    ),
    totalConsultationsRespondedLate: t(
      'total_consultations_responded_late',
      'Total number of statutory consultations with late responses issued'
    ),
    percentageConsultationsRespondedLate: t(
      'percentage_consultations_responded_late',
      'Percentage of statutory consultations with late responses issued'
    ),
    totalConsultationsWithOutstandingResponses: t(
      'total_consultations_with_outstanding_responses',
      'Total number of statutory consultations with outstanding responses'
    ),
    averageDaysTakenToRespondRequests: t(
      'average_days_taken_to_respond_requests',
      'Average number of days taken to make a substantive response to statutory requests'
    ),
  };

  return statutoryTimelinessResponseStatsLabels;
};
